import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { PricingMethod } from '@shared-features/enums/pricing-method';
import { UnitsType } from '@shared-features/enums/units-type';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-pricing-method',
  templateUrl: './pricing-method.component.html',
  styleUrls: ['./pricing-method.component.scss'],
})
export class PricingMethodComponent extends BaseComponent {
  @Input() form: FormGroup;
  @Input() isDisabled = false;
  @Input() value: PricingMethod;
  @Input() isZeroShipmentPriceSelected: boolean;
  @Input() isCustomerInheritFromOrg: boolean;
  @Input() orgPricingMethod: PricingMethod;
  @Output() selectedPricingMethod = new EventEmitter<PricingMethod>();
  protected readonly pricingMethod = PricingMethod;
  protected readonly unitsType = UnitsType;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.value) {
      this.form.get('pricingMethod').setValue(this.value);
      this.handlePricingMethodChanges(this.value);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['form'] && changes['form'].currentValue !== changes['form'].previousValue) {
      this.formSetup();
    }    
    if (
      this.isZeroShipmentPriceSelected ||
      this.isCustomerInheritFromOrg
    ) {
      this.form.get('pricingMethod').disable();
    } else if (
      !this.isZeroShipmentPriceSelected &&
      !this.isCustomerInheritFromOrg
    ) {
      this.form.get('pricingMethod').enable();
    }

    this.isZeroShipmentPriceSelected && this.form.get('pricingMethod').setValue(PricingMethod.PerTradeLane);

    if (this.isCustomerInheritFromOrg && this.orgPricingMethod ){
      this.form.get('pricingMethod').setValue(this.orgPricingMethod);
    }
  }

  handlePricingMethodChanges(selectedPricingMethod: PricingMethod) {
    if (selectedPricingMethod === PricingMethod.PerUnit) {
      this.form.get('units').setValue(UnitsType.Ton);
    } else {
      this.form.get('units').setValue(null);
    }
    this.form.updateValueAndValidity();
  }

  onPricingMethodChanges(pricingMethod: PricingMethod){
    this.selectedPricingMethod.emit(pricingMethod);
  }

  formSetup() {
    this.form.addControl(
      'pricingMethod',
      new FormControl(PricingMethod.PerTradeLane, Validators.required)
    );
    this.form.addControl('units', new FormControl(''));

    this.form.controls['pricingMethod'].valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((selectedPricingMethod) => {
        this.handlePricingMethodChanges(selectedPricingMethod);
      });
  }
}
